// 办公室卡片图片轮播(全球视野分区 office-card 块专用)
// 参考 Swiper 官方 slides-scale 演示:活动图原大居中,非活动图缩小弱化(缩放规则在
// global-vision.css 中),同屏最多显示三张;两张图片起即轮播,单张静态展示不接管;
// 幻灯片不足无缝循环门槛时不循环不自动播放,不超过同屏数时全部平铺显示
// 另含幻灯片内多图切换(office-image 的图片项子块 office-image-item):
// 堆叠成员两张起在图片右下角创建序号分页器,点击对应序号切换到对应图片
// 需在 swiper-bundle.min.js 之后 defer 加载(分区文件中按顺序输出)
// 幂等设计:重复加载/执行安全(编辑器局部刷新会重新注入 script 标签,直接跳过),
// 已初始化容器靠 data-office-swiper 标记跳过;
// MutationObserver 与 shopify 编辑器事件兑底接管编辑器重渲染注入的新 DOM
(function () {
  if (window.__officeCardImagesLoaded) return;
  window.__officeCardImagesLoaded = true;

  // 根字号(px):图片间距按 rem 设定,Swiper spaceBetween 只收 px,换算保持随根字号等比
  function rootFontSize() {
    return parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
  }

  // 图片间距(rem):同屏三张窗口的图片间距,与卡片文字区内边距呼应
  var IMAGE_GAP_REM = 1.6;

  function initCardImages() {
    // 幻灯片内多图与外层轮播无依赖,先于 Swiper 接管
    initSlideStacks();

    document.querySelectorAll('[data-office-images]').forEach(function (images) {
      if (images.dataset.officeSwiper === 'true') return;

      var slides = images.querySelectorAll('.swiper-slide');
      // 单张图片无切换内容,不初始化 Swiper,静态占满图片区(样式 flex: 1 兜底)
      if (slides.length < 2) return;

      images.dataset.officeSwiper = 'true';

      var autoplayOption = false;
      if (images.dataset.officeAutoplay === 'true') {
        // 输入防护:number 设置无 min/max 校验,下限 2 秒避免过快切换
        var delaySec = Math.max(2, parseFloat(images.dataset.officeDelay || '5') || 5);
        autoplayOption = {
          delay: delaySec * 1000,
          disableOnInteraction: false,
        };
      }

      // 幻灯片固定宽度(rem):0 表示未设置,同屏三张自动平分;
      // 设置后桌面端 slidesPerView 切 auto 尊重 CSS 固定宽度,可见数按容器实测推算
      var slideWRem = parseFloat(images.dataset.officeSlideWidth || '0') || 0;
      var gapPx = IMAGE_GAP_REM * rootFontSize();

      // 同屏可见数:移动端(<=749px)主图居中+两侧各露约1/5(总宽约1.4张),
      // 桌面端默认三张,固定宽度时按容器实测推算同屏可见数;
      // 移动端恒走数字模式等分容器:固定 rem 宽度在窄屏会超出容器宽度,
      // 无法形成两侧各露约1/5的居中效果,固定宽度设置仅桌面端生效
      var isMobile = window.innerWidth <= 749;
      var perView = isMobile ? 1.4 : 3;
      if (!isMobile && slideWRem > 0) {
        var slideWPx = slideWRem * rootFontSize();
        perView = Math.max(1, Math.floor((images.clientWidth + gapPx) / (slideWPx + gapPx)));
      }
      // 数字模式:幻灯片宽度由 Swiper 写内联宽度按容器等分;
      // 仅桌面端设置固定宽度时为 false(宽度交给 CSS,slidesPerView 切 auto)
      var numericMode = slideWRem <= 0 || isMobile;
      var seamlessLoop = slides.length >= perView + 2;
      // 全部塞得下(张数不超过同屏数)时无滚动空间:centeredSlides 会把首张
      // 居中、末张推出容器(三张填满时刷新只见两张),关闭居中从首位排起全部显示
      var fitsAll = slides.length <= perView;

      // 无导航控件:自动播放+触摸滑动切换,数字分页已按需求移除
      new Swiper(images, {
        slidesPerView: numericMode ? perView : 'auto',
        centeredSlides: !fitsAll,
        // 初始居中张:移动端刷新后默认第二张居中(首张居中时左侧无前序
        // 内容,仅右侧露边不对称;第二张起两侧各露前后张约1/5边缘)
        initialSlide: isMobile ? 1 : 0,
        spaceBetween: gapPx,
        // 滚动切换速度(demo 默认值);幻灯片缩放过渡时长由卡片块设置
        // 独立控制(--gv-slide-transition),不与本值强制同步
        speed: 300,
        loop: seamlessLoop,
        rewind: false,
        autoplay: seamlessLoop ? autoplayOption : false
      });

      // 全部塞得下时中间张为视觉主角(原大,两侧缩小),与居中轮播的活动图
      // 居中语义一致;自定义类不参与 Swiper 的 active 类管理,
      // refreshSwipers 的 update() 重算 active 也不会把它清掉;
      // 此时无滚动空间交互不动,中间张稳定保持主角位
      if (fitsAll) {
        slides[Math.floor((slides.length - 1) / 2)].classList.add('office-card__slide-focus');
      }

      // 初始化竞态修复(实测):Swiper 偶发只给首张幻灯片写入内联宽度,
      // 其余幻灯片无宽度时退化为内容宽(图片加载前塌窄,同屏多张挤压,
      // 现象:刷新后不足三张完整,交互后才恢复);
      // 以首张(必被写入)的宽度为基准补写全部缺失的幻灯片,
      // 含 loop 复制出的节点——构造完成后复制 DOM 已就绪,重新查询取全量;
      // 桌面端固定宽度模式(slide_width>0)下幻灯片宽度由 CSS 提供,无需补写
      if (numericMode) {
        var stdWidth = images.querySelector('.swiper-slide').style.width;
        if (stdWidth) {
          images.querySelectorAll('.swiper-slide').forEach(function (slide) {
            if (!slide.style.width) slide.style.width = stdWidth;
            // 内联锁定不收缩:实测部分幻灯片 computed flex 为 1 1 auto
            // (来源未定位),若为内联则 CSS 类规则无法覆盖,此处内联压内联
            slide.style.flex = '0 0 auto';
          });
        }
      }
    });
  }

  // 幻灯片内多图切换(office-image 的图片项子块 office-image-item,无主图设置):
  // 堆叠成员(图片项盒子)两张起在图片右下角创建序号分页器,
  // 点击对应序号直接显示对应子块的图(当前序号高亮),
  // 只切换本幻灯片堆叠内的图片(is-hidden 类),不触碰外层卡片 Swiper 实例;
  // 默认显示第一个子块的图——未接管时靠 CSS 隐藏首个图片项之后的兄弟
  // (global-vision.css),接管后加 --ready 类解除被规则、由 is-hidden 统一
  // 管理可见性,两个机制衔接保证 JS 加载前后均默认只显示第一张且不闪现;
  // 未选图的空图片项不参与计数与切换(跳过无 img 的成员);
  // 幂等:已接管堆叠靠 data-slide-stack-ready 标记跳过,
  // 编辑器重渲染注入的新 DOM 由 MutationObserver/编辑器事件兑底接管
  // (initCardImages 统一入口调用)
  function initSlideStacks() {
    document.querySelectorAll('[data-slide-stack]').forEach(function (stack) {
      if (stack.dataset.slideStackReady === 'true') return;
      stack.dataset.slideStackReady = 'true';

      // 堆叠成员:图片项盒子(office-card__stack-item,第一个默认显示),
      // :scope > 限定直接子元素不误伤导航按钮内的 svg;
      // 占位图为 svg 标签不入列(无子块时单成员本就无切换)
      var members = [];
      stack.querySelectorAll(':scope > .office-card__stack-item').forEach(function (el) {
        if (el.querySelector('img')) members.push(el);
      });
      if (members.length < 2) return;

      // 接管可见性:非首成员统一 is-hidden 隐藏,此后切换只维护本类
      members.forEach(function (el, i) {
        el.classList.toggle('is-hidden', i !== 0);
      });
      stack.classList.add('office-card__image-stack--ready');

      // 图片右下角分页器:序号胶囊按钮与子块图一一对应,
      // 点击对应序号显示对应子块的图,当前序号高亮(is-active);
      // 随幻灯片 scale 缩放属预期(与图片一体)
      var pagination = document.createElement('div');
      pagination.className = 'office-card__image-pagination';
      members.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'office-card__image-pagination-btn';
        btn.textContent = i + 1;
        btn.setAttribute('aria-label', '第 ' + (i + 1) + ' 张图片');
        pagination.appendChild(btn);
      });
      stack.appendChild(pagination);
      var btns = Array.prototype.slice.call(pagination.children);

      // 统一切换:同步堆叠可见性与分页器高亮
      function show(i) {
        members.forEach(function (el, j) {
          el.classList.toggle('is-hidden', j !== i);
        });
        btns.forEach(function (btn, j) {
          btn.classList.toggle('is-active', j === i);
        });
      }
      show(0);

      pagination.addEventListener('click', function (e) {
        var btn = e.target.closest('.office-card__image-pagination-btn');
        if (!btn) return;
        // 阻止默认与冒泡,避免点击波及外层轮播的拖动/点击判定
        e.preventDefault();
        e.stopPropagation();
        show(btns.indexOf(btn));
      });
    });
  }

  // 移动端阈值(px):与 global-vision.css @media (max-width:749px) 对齐,
  // 跨阈值时 slidesPerView/centeredSlides/initialSlide 等参数需重建而非 update
  var MOBILE_BREAKPOINT = 749;
  // 上次刷新时的移动端状态,用于检测是否跨阈值
  var lastIsMobile = window.innerWidth <= MOBILE_BREAKPOINT;

  // 销毁并重建所有实例:跨移动端/PC 阈值时调用。
  // Swiper 参数(slidesPerView/centeredSlides/initialSlide)按窗口宽度判定,
  // update() 不会改变这些参数,必须销毁旧实例、清除接管标记后重新初始化
  function reinitSwipers() {
    document.querySelectorAll('[data-office-images]').forEach(function (el) {
      var swiper = el.swiper;
      if (swiper && !swiper.destroyed) {
        swiper.destroy(true, true);
      }
      delete el.dataset.officeSwiper;
      // 清除旧实例写入的内联宽度/flex,避免重建时补写逻辑用到旧值
      el.querySelectorAll('.swiper-slide').forEach(function (s) {
        s.style.width = '';
        s.style.flex = '';
      });
      // 清除 fitsAll 场景下手动加的主角类(重建后由新逻辑决定)
      el.querySelectorAll('.office-card__slide-focus').forEach(function (s) {
        s.classList.remove('office-card__slide-focus');
      });
    });
    initCardImages();
  }

  // 刷新所有实例:重算间距并按当前容器宽度重排幻灯片。
  // 容器宽度是响应式的(窄视口时随 100% 减边距变化),而初始化时
  // swiper/global-vision 样式可能尚未应用完成,测量失真会让幻灯片
  // 内联宽度按错误值写入(现象:刷新后同屏不是三张完整,交互后才恢复),
  // update() 按当前真实尺寸重算宽度与滚动位置。
  // 若窗口宽度跨越移动端阈值,则销毁重建以应用新参数
  function refreshSwipers() {
    var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    if (isMobile !== lastIsMobile) {
      lastIsMobile = isMobile;
      reinitSwipers();
      return;
    }
    document.querySelectorAll('[data-office-images]').forEach(function (el) {
      var swiper = el.swiper;
      if (!swiper || swiper.destroyed || !el.isConnected) return;
      swiper.params.spaceBetween = IMAGE_GAP_REM * rootFontSize();
      swiper.update();
    });
  }

  // 窗口尺寸变化:重算间距并重排幻灯片宽度(容器宽度随视口变化);
  // rAF 节流,resize 高频触发下每帧最多刷新一次;
  // 实例从容器的 el.swiper 取(Swiper 11 挂载),无需维护实例列表
  var resizeTicking = false;
  window.addEventListener('resize', function () {
    if (resizeTicking) return;
    resizeTicking = true;
    requestAnimationFrame(function () {
      resizeTicking = false;
      refreshSwipers();
    });
  });

  // 首屏布局兜底:双帧 rAF(布局+绘制两轮稳定)与整页加载后渐进多次重算
  // (立即/100ms/300ms,覆盖图片与字体加载、编辑器重排等后续布局变化),
  // 保证首屏按真实容器宽度排布三张完整幻灯片
  requestAnimationFrame(function () {
    requestAnimationFrame(refreshSwipers);
  });

  window.addEventListener('load', function () {
    refreshSwipers();

    setTimeout(refreshSwipers, 100);
    setTimeout(refreshSwipers, 300);
  });

  // 编辑器兜底一:主题编辑器更新块/分区时,新 DOM 经 innerHTML 注入,
  // 注入内容中的脚本不会执行,由本观察器自动接管(幂等,已接管的靠标记跳过)
  new MutationObserver(function () {
    if (document.readyState === 'loading') return;
    initCardImages();
  }).observe(document.body, { childList: true, subtree: true });

  // 编辑器兜底二:监听编辑器事件(分区重渲染/块选中)接管
  ['shopify:section:load', 'shopify:block:select'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      initCardImages();
    });
  });

  // 首次加载时(解析中)等待 DOMContentLoaded(defer 的 Swiper 库此时也已就绪),否则立即初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardImages);
  } else {
    initCardImages();
  }
})();
